module.exports = __webpack_public_path__ + "img/img-cardnews-02-2.fced8d0e.png";